import { jsx as _jsx } from "react/jsx-runtime";
import { moduleLabel } from '../lib/modules';
/**
 * Toggleable module pills, shared by the super-admin commune form and the
 * commune-agent settings so both render modules identically (and with the same
 * human-readable labels).
 */
export function ModulePills({ modules, selected, onToggle, disabled = false, lockedKeys = [] }) {
    return (_jsx("div", { className: "flex flex-wrap gap-2", children: modules.map((mod) => {
            const active = selected.includes(mod);
            const locked = disabled || lockedKeys.includes(mod);
            return (_jsx("button", { type: "button", disabled: locked, onClick: () => onToggle(mod), className: `px-3 py-1.5 text-xs rounded-full border transition-colors ${active
                    ? 'bg-blue-600 text-white border-blue-600'
                    : 'bg-white text-gray-600 border-gray-300 hover:border-gray-400'} ${locked ? 'opacity-60 cursor-not-allowed' : ''}`, children: moduleLabel(mod) }, mod));
        }) }));
}
